module.exports = __webpack_public_path__ + "img/user_favorites_page_banner.064537a2.png";